<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleLotti > 0"
      item-key="_id"
      :headers="headers"
      :items="lotti"
      :options.sync="options"
      :server-items-length="totaleLotti"
      :loading="loading"
      class="elevation-1"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [10, 15, 50, 100]
      }"
      :items-per-page="15"
      dense
    >
    <template v-slot:[`item.data`]="{ item }">
      {{ item.data | dateTime }}
    </template>
    <template v-slot:[`item.dataScadenza`]="{ item }">
      {{ item.custom && item.custom.scadenza | dateNull }}
    </template>    
    
    <template v-slot:no-data>
      Nessun dato disponibile
    </template>
    </v-data-table>
   </div>
</template>

<script>
  import _ from 'lodash'
  // import { dynamicSortMultiple } from '@/components/helpers.js'
/*   import configurazioni from '@/services/configurazioniService.js'
  import moment from 'moment' */
  import documenti from '@/services/documentiService.js'
/*   import etichetteService from '@/services/etichetteService.js'
  import reporting from '@/services/reportingService.js' */

  export default {
    components: {
    },
    props: {
      item: Object,
      refresh: Number
    },
    data () {
      return {
        totaleLotti: 0,
        lotti: [],
        selected: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Tipo', value: 'tipoDocumento.descrizione', align: 'start'},
          { text: 'Numero', value: '_id'},
          { text: 'Data', value: 'data' },
          { text: 'Scadenza', value: 'dataScadenza' },
          { text: 'Info', value: 'custom.info' },
          { text: 'Riferimento', value: 'custom.riferimento' },
          { text: 'Stato', value: 'stato.descrizione' }
/*           { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' } */
        ],
        expanded: [],
        singleExpand: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: null,
        tab: null,
        pathEtichettePrefix: '',
        usaQtaAnagrafica: false,
        // salta: 0,
        tipoStampa: '',
        report: '',
        isModuloA4: false,
        errorTitle: 'Errore aggiornamento Lotto',
        errorMessage: '',
        showDialogMultiple: false,
        showDettaglioFattura: false,
        triggerUpdate: 1,
        triggerDettaglio: 1,
        idDocumento: null,
        showLottoAcquisto: false,
        showLottoAssemblaggio: false,
        showLottoProduzione: false,
        readOnly: false,
        lottoCollegato: {}
      }
    },
    async created() {
      // this.pathEtichettePrefix = config.VUE_APP_service_etichette || '',
      // await this.getDefaultItem()
    },
    computed: {
      lottiSorted() {
        const els = this.lotti
        // const elSorted = els.sort(dynamicSortMultiple('_id'))
        const elSorted = _.sortby(els, ['_id'])
        return elSorted
      }
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      },
      async refresh(value) {
        if (value) {
          this.options.page = 1
          await this.getDataFromApi()
        }
      }
    },
    methods: {
      async getDataFromApi () {
        try {
          this.loading = true
          const filtri = { base: this.item.codice }
          filtri.tipoDocumento =  ['lottoAcquisto', 'lottoAssemblaggio', 'lottoProduzione', 'lottoSezionamento']
          const data = await documenti.getFilteredDocumentHeaders(filtri, this.options)
          this.lottiRaw = data && data.total_rows > 0 ? data.rows : []
          let docs = this.datiVisualizzazione(this.lottiRaw)
          if (!_.get(this.item, 'lotti.prodottoBase')) {
            // Se non è un prodotto base, tra tutti i lotti ritornati filtra quelli relativi all'id del prodotto
            const lotto = _.get(this.item, 'lotti.lotto') || ''
            docs = docs.filter(x => x._id === lotto)
          }
          this.lotti = docs 
          this.totaleLotti = data.total_rows
        } catch(err) {
          this.lotti = []
          this.totaleLotti = 0
        } finally {
          this.loading = false
        }
      },         
      datiVisualizzazione(lotti) {
        const elaborati = lotti.map(el => {
         // const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.descrizione) || (el.anagrafica.cliente && el.anagrafica.cliente.descrizione)
          const nominativo = el.anagrafica && ((el.anagrafica.fornitore && el.anagrafica.fornitore.codice) || (el.anagrafica.cliente && el.anagrafica.cliente.codice)) || ''
          return { ...el, c_nominativo: nominativo }
        })
        return elaborati
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }

  td.td-lotto-selected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
